import { orange, blue, green } from '@mui/material/colors'
import T from 'T'

export const INVOICE_STATUS = {
  NOT_READY_FOR_INVOICE: 'NOT_READY_FOR_INVOICE',
  READY_FOR_INVOICE: 'READY_FOR_INVOICE',
  INVOICED: 'INVOICED',
}

export const INVOICE_STATUS_DISPLAY = {
  NOT_READY_FOR_INVOICE: { title: T.NOT_READY_FOR_INVOICE_LABEL, text: T.NOT_READY_FOR_INVOICE_TEXT, type: 'warning', bgColor: orange[100] },
  READY_FOR_INVOICE: { title: T.READY_FOR_INVOICE_LABEL, text: T.READY_FOR_INVOICE, type: 'success', bgColor: green[100] },
  INVOICED: { title: T.INVOICED, text: T.INVOICED, type: 'info', bgColor: blue[100] },
}
